import { Admin } from "src/models/admin";
import { ApiService } from "../apiService";
import { UserInfo } from "src/models/userInfo";
import { ServiceLog } from "src/sections/superadmin/logMaintenance";

const apiService = new ApiService();

export const getAllAdmins = async () => await apiService.get<Admin[]>(`SuperAdmin/GetAdminUsers`);

export const updateAdmin = async(data:any) => await apiService.post(`SuperAdmin/UpdateAdminUser`,data);

export const createAdmin = async(data:any) => await apiService.post(`SuperAdmin/CreateAdminProfile`,data);

export const getAllDoctors = async () => await apiService.get<UserInfo[]>(`SuperAdmin/GetDoctorProfile`);

export const getAllPatients = async () => await apiService.get<UserInfo[]>(`SuperAdmin/GetPatientProfile`);

export const deleteProfile = async(id:any) => await apiService.post(`SuperAdmin/DeleteProfile?id=${id}`,{});

export const getAllLogs = async () => await apiService.get<ServiceLog[]>(`SuperAdmin/GetServiceLog`);

export const createServiceLog = async(data:any) => await apiService.post(`SuperAdmin/CreateServiceLog`,data);
export const updateDoctorStatus = async (data: { userId: number; isActive: boolean }) => 
  await apiService.post(`SuperAdmin/UpdateDoctorStatus`, data);